import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setCommonAreaAssetFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};
const clearCommonAreaAssetFormData = (state) =>{
    return {
      ...state,
      data:{}
    }
  }

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_COMMON_AREA_ASSET_FORM_DATA]: setCommonAreaAssetFormData,
  [TYPES.CLEAR_COMMON_AREA_ASSET_FORM_DATA] : clearCommonAreaAssetFormData
});
